import { render, staticRenderFns } from "./training_card.vue?vue&type=template&id=05452a88&scoped=true&"
import script from "./training_card.vue?vue&type=script&lang=js&"
export * from "./training_card.vue?vue&type=script&lang=js&"
import style0 from "./training_card.vue?vue&type=style&index=0&id=05452a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05452a88",
  null
  
)

export default component.exports